import React, { useState, useEffect } from "react";
import styles from "./BrandLayout.module.css";
import { useTranslation } from "react-i18next";
import BrandInfo from "./BrandInfo/BrandInfo";
import Branding from "./Branding/Branding";
import Subscription from "./Subscription.js/Subscription";
import Password from "./Password/Password";
import { useContext } from "react";
import { UserContext } from "../../Context/UserContext";
import { useDispatch } from "react-redux";
import { is_modal_open } from "../../redux/slices/userSlice";
import CustomTabButton from "../../ReactBootstrap/CustomTabButton";
import { useSelector } from "react-redux";

function BrandLayout() {
  const signupType = useSelector((state) => state.user.signupType);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isAnyChange, setSaveChanges } = useContext(UserContext);
  const [tabIndex, setTabIndex] = useState(1);
  const [showtab, setShowtab] = useState(1);

  const handleTabChange = () => {
    setShowtab(tabIndex);
    setSaveChanges(false);
  };

  useEffect(() => {
    if (!isAnyChange) {
      handleTabChange();
    }
  }, [isAnyChange, tabIndex]);

  const handleTryToChangeTab = (index) => {
    setTabIndex(index);
    if (isAnyChange) {
      dispatch(is_modal_open());
    }
  };

  return (
    <div>
      <p className={styles.heading}>
        {showtab === 1 || showtab === 2
          ? t("BRAND INFO")
          : t("BRAND_INFO_SUBSCRIPTION")}
      </p>

      <div className={styles.devider}></div>

      <div className={styles.option}>
        <div className={styles.buttonSection}>
          <CustomTabButton
            onClick={() => handleTryToChangeTab(1)}
            variant={showtab === 1 ? "primary" : "secondary"}
          >
            {t("BRAND_INFO")}
          </CustomTabButton>
          <CustomTabButton
            onClick={() => handleTryToChangeTab(2)}
            variant={showtab === 2 ? "primary" : "secondary"}
          >
            {t("BRANDING_")}
          </CustomTabButton>
          <CustomTabButton
            onClick={() => handleTryToChangeTab(3)}
            variant={showtab === 3 ? "primary" : "secondary"}
          >
            {t("SUBSCRIPTION_")}
          </CustomTabButton>

          <CustomTabButton
            onClick={() => handleTryToChangeTab(4)}
            variant={showtab === 4 ? "primary" : "secondary"}
          >
            {t("PASSWORD")}
          </CustomTabButton>

          {/* {signupType !== 2 && (
            <CustomTabButton
              onClick={() => handleTryToChangeTab(4)}
              variant={showtab === 4 ? "primary" : "secondary"}
            >
              {t("PASSWORD")}
            </CustomTabButton>
          )} */}
        </div>
      </div>
      <div className={styles.devider}></div>

      {/* {showtab === 1 ? (
        <BrandInfo />
      ) : showtab === 2 ? (
        <Branding />
      ) : showtab === 3 ? (
        <Subscription />
      ) : showtab === 4 && signupType !== 2 ? (
        <Password />
      ) : (
        ""
      )} */}

      {showtab === 1 ? (
        <BrandInfo />
      ) : showtab === 2 ? (
        <Branding />
      ) : showtab === 3 ? (
        <Subscription />
      ) : showtab === 4 ? (
        <Password />
      ) : (
        ""
      )}
    </div>
  );
}

export default BrandLayout;
